module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"count":"Count","rate":"Rate","time":"time | times"},"ja":{"count":"回数","rate":"割合","time":"回"},"zh-hant":{"count":"次數","rate":"比率","time":"回"},"zh-hans":{"count":"次数","rate":"比率","time":"回"}}')
  delete Component.options._Ctor
}
